import moment from "moment";
import {
	computeRelativeDateRange,
	DATE_PRESET_CUSTOM,
} from "utils/relativeDatePresets";
import { isAllowedSummaryPeriod } from "./aggregate";

const STORAGE_START = "attendance_summary_start";
const STORAGE_END = "attendance_summary_end";
const STORAGE_PRESET = "attendance_summary_preset";
const STORAGE_EMPLOYEES = "attendance_summary_employeeIds";
const STORAGE_GROUP = "attendance_summary_groupId";
const STORAGE_UBICATION = "attendance_summary_ubicationId";

export const SUMMARY_PRESETS = [
	"yesterday",
	"today",
	"this_week",
	"this_month",
	"last_7_days",
	"last_30_days",
];

function readScope() {
	return {
		employeeIds: localStorage.getItem(STORAGE_EMPLOYEES) || "",
		groupId: localStorage.getItem(STORAGE_GROUP) || "",
		ubicationId: localStorage.getItem(STORAGE_UBICATION) || "",
	};
}

export function readSummaryFilters(now = moment()) {
	const scope = readScope();
	const preset = localStorage.getItem(STORAGE_PRESET) || "this_week";

	if (preset !== DATE_PRESET_CUSTOM && SUMMARY_PRESETS.includes(preset)) {
		const range = computeRelativeDateRange(preset, now);
		if (range?.start && range?.end && isAllowedSummaryPeriod(range.start, range.end)) {
			return {
				startDate: range.start.format("YYYY-MM-DD"),
				endDate: range.end.format("YYYY-MM-DD"),
				preset,
				...scope,
			};
		}
	}

	const start = localStorage.getItem(STORAGE_START);
	const end = localStorage.getItem(STORAGE_END);
	if (start && end && isAllowedSummaryPeriod(start, end)) {
		return {
			startDate: moment(start).format("YYYY-MM-DD"),
			endDate: moment(end).format("YYYY-MM-DD"),
			preset: DATE_PRESET_CUSTOM,
			...scope,
		};
	}

	const week = computeRelativeDateRange("this_week", now);
	return {
		startDate: week.start.format("YYYY-MM-DD"),
		endDate: week.end.format("YYYY-MM-DD"),
		preset: "this_week",
		...scope,
	};
}

export function shiftSummaryRange(startDate, endDate, direction) {
	const start = moment(startDate).startOf("day");
	const end = moment(endDate).startOf("day");
	const days = Math.max(1, end.diff(start, "days") + 1);
	const delta = Number(direction) * days;
	return {
		startDate: start.clone().add(delta, "days"),
		endDate: end.clone().add(delta, "days"),
	};
}

export function writeSummaryFilters(filters) {
	localStorage.setItem(STORAGE_PRESET, filters.preset || DATE_PRESET_CUSTOM);
	localStorage.setItem(STORAGE_START, filters.startDate || "");
	localStorage.setItem(STORAGE_END, filters.endDate || "");
	localStorage.setItem(STORAGE_EMPLOYEES, filters.employeeIds || "");
	localStorage.setItem(STORAGE_GROUP, filters.groupId || "");
	localStorage.setItem(STORAGE_UBICATION, filters.ubicationId || "");
}
